var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNavLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_212_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10C6 5.58172 9.58172 2 14 2H38C42.4183 2 46 5.58172 46 10V34C46 38.4183 42.4183 42 38 42H14C9.58172 42 6 38.4183 6 34V10Z",
    fill: "url(#paint0_linear_212_1481)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 36H15V8H37.5V36Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2501 13.375C25.9653 13.375 25.684 13.4242 25.4168 13.5191L15.5555 17.0805C15.2215 17.2035 15.0001 17.5199 15.0001 17.875C15.0001 18.2301 15.2215 18.5465 15.5555 18.6695L17.5911 19.4043C17.0145 20.3113 16.6876 21.3836 16.6876 22.5121V23.5C16.6876 24.4984 16.3079 25.5285 15.9036 26.3406C15.6751 26.7977 15.4149 27.2477 15.1126 27.6625C15.0001 27.8137 14.9684 28.0105 15.0317 28.1898C15.095 28.3691 15.2426 28.5027 15.4254 28.5484L17.6754 29.1109C17.8231 29.1496 17.9813 29.1215 18.1114 29.0406C18.2415 28.9598 18.3329 28.8262 18.361 28.675C18.6633 27.1703 18.5122 25.8203 18.2872 24.8535C18.1747 24.3543 18.0235 23.8445 17.8126 23.377V22.5121C17.8126 21.4504 18.1711 20.4484 18.7934 19.6469C19.2469 19.102 19.834 18.6625 20.5231 18.3918L26.0426 16.2227C26.3309 16.1102 26.6579 16.2508 26.7704 16.5391C26.8829 16.8273 26.7422 17.1543 26.454 17.2668L20.9344 19.4359C20.4985 19.6082 20.1153 19.8719 19.8024 20.1953L25.4133 22.2203C25.6805 22.3152 25.9618 22.3645 26.2465 22.3645C26.5313 22.3645 26.8126 22.3152 27.0797 22.2203L36.9446 18.6695C37.2786 18.55 37.5001 18.2301 37.5001 17.875C37.5001 17.5199 37.2786 17.2035 36.9446 17.0805L27.0833 13.5191C26.8161 13.4242 26.5348 13.375 26.2501 13.375ZM19.5001 26.5938C19.5001 27.8348 22.5235 29.125 26.2501 29.125C29.9766 29.125 33.0001 27.8348 33.0001 26.5938L32.4622 21.482L27.4629 23.2891C27.0727 23.4297 26.6614 23.5 26.2501 23.5C25.8387 23.5 25.4239 23.4297 25.0372 23.2891L20.0379 21.482L19.5001 26.5938Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_212_1481",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_1481"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_212_1481",
    result: "effect2_dropShadow_212_1481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_212_1481",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_1481",
    x1: -8.14214,
    y1: 16.1421,
    x2: 20.1421,
    y2: 44.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4685D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1481"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 12.25H37.5V30.25H15V12.25Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavLogo);
export default __webpack_public_path__ + "static/media/ic_nav_logo.2aad88ef2bb468da9038045433b025a3.svg";
export { ForwardRef as ReactComponent };